import { h } from 'preact';

export default props => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" {...props}>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M22.6321 12.8895L2.86257 23.8725C2.37192 24.1456 1.75265 23.9686 1.47961 23.4775C1.39622 23.3265 1.352 23.1566 1.352 22.9838V1.01775C1.352 0.455916 1.80706 0.000854492 2.3689 0.000854492C2.54177 0.000854492 2.71157 0.0450967 2.86257 0.128991L22.6321 11.1115C23.1233 11.3845 23.2997 12.0038 23.0272 12.4945C22.9351 12.6607 22.7984 12.7975 22.6321 12.8895Z" />
	</svg>
);